import React from "react";

const About = () => {
  return (
    <div>
      <div class=" flex flex-row justify-center pt-10 font-bold">
        <button class="p-4 mr-5 bg-gray-200 rounded-lg text-indigo-400">
          ABOUT
        </button>
      </div>
      <div>
        <p class="p-8 italic">
          A recent BCA graduate with a passion for web development. I have
          learnt HTML, CSS, JavaScript, ReactJS, and NodeJS, and I am eager to
          apply my skills to create innovative and user-friendly web
          applications. I am a quick learner and I am always up for a challenge
          & I'm confident that I can contribute to any team.
        </p>
      </div>
    </div>
  );
};

export default About;
